import axios from 'axios';

const axiosConfig = {
  baseURL: process.env.NX_BASE_URL,
};
const axiosInstance = axios.create(axiosConfig);

export default axiosInstance;
